"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[276],{

/***/ 20516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ ExpandButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78296);
/* harmony import */ var src_components_icons_ChevronBottom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56647);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68251);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87379);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        transform: rotate(180deg);\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  margin-bottom: 8px;\n  svg {\n    ",
        "\n    margin: 0 0 0 7px;\n    ",
        " {\n      margin: 0 7px 0 0;\n    }\n  }\n  ",
        " {\n    margin-left: 0;\n    margin-right: auto;\n    ",
        " {\n      margin-right: 0;\n      margin-left: -20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n  line-height: 18px;\n  text-transform: lowercase;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_2__/* .CleanButton */ .ux).withConfig({
    displayName: "ExpandButton__Button",
    componentId: "sc-81753a5-0"
})(_templateObject1(), function(param) {
    var $active = param.$active;
    return $active && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject());
}, src_styles_theme__WEBPACK_IMPORTED_MODULE_5__/* .dirRTL */ .gX, src_styles_theme__WEBPACK_IMPORTED_MODULE_5__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_4__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);
var Text = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].p.withConfig({
    displayName: "ExpandButton__Text",
    componentId: "sc-81753a5-1"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
});
var ExpandButton = function(_param) {
    var active = _param.active, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "active",
        "onClick"
    ]);
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_8__.useTranslate)()._;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        $active: active,
        onClick: onClick
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                children: _(active ? "Read less" : "Read more")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_icons_ChevronBottom__WEBPACK_IMPORTED_MODULE_3__/* .ChevronBottom */ .B, {
                size: 13
            })
        ]
    }));
};


/***/ }),

/***/ 16001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ScrollToSectionOnClick; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63085);
/* harmony import */ var src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47631);







var ScrollToSectionOnClick = function(_param) {
    var children = _param.children, id = _param.id, _offset = _param.offset, offset = _offset === void 0 ? 0 : _offset, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "id",
        "offset"
    ]);
    var ref;
    var layoutRegisterContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__/* .LayoutRegisterContext */ .D);
    var scrollToSection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(px) {
        var section = document === null || document === void 0 ? void 0 : document.querySelector("#".concat(id));
        if (section != null) {
            var ref;
            var _fixed;
            window.scrollTo({
                top: section.getBoundingClientRect().top + window.scrollY - offset * px - ((_fixed = (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed) !== null && _fixed !== void 0 ? _fixed : 0) * px,
                behavior: "smooth"
            });
        }
    }, [
        id,
        offset,
        (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed
    ]);
    var clickCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e, px) {
        var _props, ref, ref1;
        (ref = (_props = children.props).onClick) === null || ref === void 0 ? void 0 : ref.call(_props, e);
        (ref1 = props.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(props, e);
        scrollToSection(px);
    }, [
        children.props,
        props,
        scrollToSection
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveUnit */ .D, {
        children: function(px) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(children, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
                onClick: function(e) {
                    return clickCallback(e, px);
                }
            }));
        }
    });
};


/***/ }),

/***/ 77314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ContentSwiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72873);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10395);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68251);
/* harmony import */ var src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52178);
/* harmony import */ var src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18709);
/* harmony import */ var src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38108);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  left: 0;\n  overflow: visible;\n  ",
        " {\n    display: flex;\n    justify-content: center;\n\n    .swiper-wrapper {\n      width: max-content;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StyledSwiper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t).withConfig({
    displayName: "ContentSwiper__StyledSwiper",
    componentId: "sc-6f9c2f7b-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ContentSwiper = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var nextRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), swiper = ref[0], setSwiper = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (swiper && prevRef.current && nextRef.current && swiper.navigation) {
            swiper.navigation.init();
            swiper.navigation.update();
        }
    }, [
        swiper
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSwiper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        threshold: 15,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        wrapperTag: "ul",
        onSwiper: setSwiper,
        navigation: {
            prevEl: prevRef.current,
            nextEl: nextRef.current
        }
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Theme */ .Q, {
                theme: src_styles_theme__WEBPACK_IMPORTED_MODULE_6__/* .darkTheme */ .$_,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__/* .NavigationButton */ .W, {
                        kind: "circled",
                        ref: prevRef,
                        icon: src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_8__/* .ChevronLeft */ .s,
                        $direction: "left"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__/* .NavigationButton */ .W, {
                        kind: "circled",
                        ref: nextRef,
                        icon: src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_9__/* .ChevronRight */ ._,
                        $direction: "right"
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 4643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ TextareaFormik; }
});

// UNUSED EXPORTS: Textarea

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./node_modules/autosize/dist/autosize.esm.js
var e,t,n="function"==typeof Map?new Map:(e=[],t=[],{has:function(t){return e.indexOf(t)>-1},get:function(n){return t[e.indexOf(n)]},set:function(n,o){-1===e.indexOf(n)&&(e.push(n),t.push(o))},delete:function(n){var o=e.indexOf(n);o>-1&&(e.splice(o,1),t.splice(o,1))}}),o=function(e){return new Event(e,{bubbles:!0})};try{new Event("test")}catch(e){o=function(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!1),t}}function r(e){var t=n.get(e);t&&t.destroy()}function i(e){var t=n.get(e);t&&t.update()}var l=null;"undefined"==typeof window||"function"!=typeof window.getComputedStyle?((l=function(e){return e}).destroy=function(e){return e},l.update=function(e){return e}):((l=function(e,t){return e&&Array.prototype.forEach.call(e.length?e:[e],function(e){return function(e){if(e&&e.nodeName&&"TEXTAREA"===e.nodeName&&!n.has(e)){var t,r=null,i=null,l=null,d=function(){e.clientWidth!==i&&c()},a=function(t){window.removeEventListener("resize",d,!1),e.removeEventListener("input",c,!1),e.removeEventListener("keyup",c,!1),e.removeEventListener("autosize:destroy",a,!1),e.removeEventListener("autosize:update",c,!1),Object.keys(t).forEach(function(n){e.style[n]=t[n]}),n.delete(e)}.bind(e,{height:e.style.height,resize:e.style.resize,overflowY:e.style.overflowY,overflowX:e.style.overflowX,wordWrap:e.style.wordWrap});e.addEventListener("autosize:destroy",a,!1),"onpropertychange"in e&&"oninput"in e&&e.addEventListener("keyup",c,!1),window.addEventListener("resize",d,!1),e.addEventListener("input",c,!1),e.addEventListener("autosize:update",c,!1),e.style.overflowX="hidden",e.style.wordWrap="break-word",n.set(e,{destroy:a,update:c}),"vertical"===(t=window.getComputedStyle(e,null)).resize?e.style.resize="none":"both"===t.resize&&(e.style.resize="horizontal"),r="content-box"===t.boxSizing?-(parseFloat(t.paddingTop)+parseFloat(t.paddingBottom)):parseFloat(t.borderTopWidth)+parseFloat(t.borderBottomWidth),isNaN(r)&&(r=0),c()}function u(t){var n=e.style.width;e.style.width="0px",e.style.width=n,e.style.overflowY=t}function s(){if(0!==e.scrollHeight){var t=function(e){for(var t=[];e&&e.parentNode&&e.parentNode instanceof Element;)e.parentNode.scrollTop&&t.push({node:e.parentNode,scrollTop:e.parentNode.scrollTop}),e=e.parentNode;return t}(e),n=document.documentElement&&document.documentElement.scrollTop;e.style.height="",e.style.height=e.scrollHeight+r+"px",i=e.clientWidth,t.forEach(function(e){e.node.scrollTop=e.scrollTop}),n&&(document.documentElement.scrollTop=n)}}function c(){s();var t=Math.round(parseFloat(e.style.height)),n=window.getComputedStyle(e,null),r="content-box"===n.boxSizing?Math.round(parseFloat(n.height)):e.offsetHeight;if(r<t?"hidden"===n.overflowY&&(u("scroll"),s(),r="content-box"===n.boxSizing?Math.round(parseFloat(window.getComputedStyle(e,null).height)):e.offsetHeight):"hidden"!==n.overflowY&&(u("hidden"),s(),r="content-box"===n.boxSizing?Math.round(parseFloat(window.getComputedStyle(e,null).height)):e.offsetHeight),l!==r){l=r;var i=o("autosize:resized");try{e.dispatchEvent(i)}catch(e){}}}}(e)}),e}).destroy=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],r),e},l.update=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],i),e});var d=l;/* harmony default export */ var autosize_esm = (d);

// EXTERNAL MODULE: ./src/utils/formik/commonInputToFastField.tsx
var commonInputToFastField = __webpack_require__(80263);
// EXTERNAL MODULE: ./src/components/common/Input.tsx
var Input = __webpack_require__(81278);
;// CONCATENATED MODULE: ./src/components/common/Textarea.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-top: 10px;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      label {\n        margin-top: 30px;\n      }\n      span {\n        margin-bottom: 10px;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  textarea {\n    resize: none;\n    height: auto;\n    line-height: 1.5;\n    max-height: 100px;\n  }\n  label {\n    cursor: text;\n    ",
        ";\n    height: auto;\n    padding-bottom: 10px;\n  }\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var TextareaWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Textarea__TextareaWrapper",
    componentId: "sc-41ad4b3e-0"
})(_templateObject2(), function(props) {
    return props.$placeholderVariant === "hide" && (0,styled_components_browser_esm.css)(_templateObject());
}, function(props) {
    return props.$placeholderVariant == null && (0,styled_components_browser_esm.css)(_templateObject1());
});
var Textarea = function(_param) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (ref.current) {
            autosize_esm(ref.current);
        }
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaWrapper, {
        className: className,
        $placeholderVariant: props.placeholderVariant,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, (0,_object_spread/* default */.Z)({
            ref: ref,
            as: "textarea",
            rows: 1
        }, props))
    });
};
var TextareaFormik = (0,commonInputToFastField/* commonInputToFastField */.M)(Textarea, {
    useTargetValue: true
});


/***/ }),

/***/ 19838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ File; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55537);




var File = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_1__/* .IconBox */ .zb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.5 0H9V64H55V19.6009C55.0017 19.5674 55.0025 19.5338 55.0025 19.5C55.0025 19.4662 55.0017 19.4326 55 19.3991V18.6716L54.4751 18.1467C54.4371 18.1053 54.3973 18.0655 54.3559 18.0274L36.3293 0H35.5ZM33.5 4H13V60H51V21.5H33.5V4ZM48.1717 17.5H37.5V6.82774L48.1717 17.5Z"
        })
    }));
};


/***/ }),

/***/ 7040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LDJSON; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);




var LDJSON = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    "@context": "https://schema.org"
                }, props.data))
            }
        })
    });
});


/***/ }),

/***/ 29557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MetaCanonical; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaCanonical(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: props.href
            }, "canonical"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: props.href
            }, "og:url")
        ]
    });
}


/***/ }),

/***/ 63884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ MetaImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaImage(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: props.src
            }, "og:image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }, "twitter:card")
        ]
    });
}


/***/ }),

/***/ 78162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useFastRefreshFixer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Fixes fast refresh (or hot reload), has no effect on production.
 * Set returned value as key to the element you want to force-remount after refresh.
 */ function useFastRefreshFixer() {
    return  false ? 0 : undefined;
}


/***/ }),

/***/ 36311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useIsRTL; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useMutationObserver.ts

var useMutationObserver = function(domNodeSelector, callback, observerOptions) {
    (0,react.useEffect)(function() {
        var targetNode = document.querySelector(domNodeSelector);
        var observer = new MutationObserver(callback);
        if (targetNode) {
            observer.observe(targetNode, observerOptions);
        }
        return function() {
            observer.disconnect();
        };
    }, [
        domNodeSelector,
        observerOptions,
        callback
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useIsRTL.ts


var checkIsRTL = function() {
    return typeof document !== "undefined" ? document.documentElement.dir === "rtl" : false;
};
var options = {
    attributes: true
};
var useIsRTL = function() {
    var ref = (0,react.useState)(checkIsRTL), isRTL = ref[0], setIsRTL = ref[1];
    var handler = (0,react.useCallback)(function(mutationList) {
        mutationList.forEach(function() {
            setIsRTL(checkIsRTL);
        });
    }, []);
    useMutationObserver("html", handler, options);
    return isRTL;
};


/***/ }),

/***/ 78939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ MaterialPageTabId; }
/* harmony export */ });
var MaterialPageTabId;
(function(MaterialPageTabId) {
    MaterialPageTabId["Notes"] = "NOTES";
    MaterialPageTabId["UserNotes"] = "USER_NOTES";
    MaterialPageTabId["Details"] = "DETAILS";
    MaterialPageTabId["Products"] = "PRODUCTS";
    MaterialPageTabId["Episodes"] = "EPISODES";
})(MaterialPageTabId || (MaterialPageTabId = {}));


/***/ }),

/***/ 33960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ MaterialPageLoader; },
  "r": function() { return /* binding */ MaterialPageTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/hooks/usePersonallyCraftedFLIP.ts
var usePersonallyCraftedFLIP = __webpack_require__(14592);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
// EXTERNAL MODULE: ./node_modules/react-hook-inview/dist/esm/index.js + 2 modules
var esm = __webpack_require__(69671);
// EXTERNAL MODULE: ./src/components/common/typography/Header.tsx
var Header = __webpack_require__(29894);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
;// CONCATENATED MODULE: ./src/components/common/NailTab.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: inherit;\n  font-size: 16px;\n  line-height: 131%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0rpx;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          &:not([disabled]) {\n            font-weight: 500;\n            color: ",
        ";\n\n            &::before {\n              background-color: ",
        ";\n            }\n\n            &:hover,\n            &:focus {\n              color: ",
        ";\n              &:before {\n                background-color: ",
        ";\n              }\n            }\n          }\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: row;\n  grid-gap: 2px !important;\n  text-transform: unset;\n  text-align: left;\n  margin-bottom: 0;\n  color: ",
        ";\n  padding-left: 26px;\n  font-weight: 700;\n\n  &:not(:first-of-type) {\n    margin-left: 20px;\n\n    ",
        " {\n      margin-left: 30px;\n    }\n  }\n\n  :before {\n    top: -1px;\n    width: 12px;\n    height: 50px;\n    transition: background-color ",
        "s\n      ",
        "s\n      ",
        ";\n  }\n\n  transition: color ",
        "s\n    ",
        "s\n    ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var TabHeader = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "NailTab__TabHeader",
    componentId: "sc-5ee2556d-0"
})(_templateObject());
var TabDescription = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NailTab__TabDescription",
    componentId: "sc-5ee2556d-1"
})(_templateObject1());
var NailTab = (0,styled_components_browser_esm["default"])(Header.H1).attrs({
    as: (0,motion/* motion */.E)(Button/* CleanButton */.ux)
}).withConfig({
    displayName: "NailTab",
    componentId: "sc-5ee2556d-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.buttons.default.primary.default.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration / 4;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.default;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration / 4;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.default;
}), function(param) {
    var $active = param.$active;
    return $active === false ? (0,styled_components_browser_esm.css)(_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.buttons.default.primary.disabled.primary;
    }, function(param) {
        var theme = param.theme;
        return theme.buttons.default.primary.disabled.primary;
    }, function(param) {
        var theme = param.theme;
        return theme.buttons.default.primary.default.primary;
    }, function(param) {
        var theme = param.theme;
        return theme.buttons.default.primary.default.primary;
    }) : "";
});

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./vendor/hooks/useDispatchAction.ts
var useDispatchAction = __webpack_require__(62514);
// EXTERNAL MODULE: ./src/store/actions.ts + 1 modules
var actions = __webpack_require__(88776);
// EXTERNAL MODULE: ./src/hooks/useCallbackEffects.ts + 1 modules
var useCallbackEffects = __webpack_require__(48363);
// EXTERNAL MODULE: ./src/utils/eventHandlerHelpers.ts
var eventHandlerHelpers = __webpack_require__(89755);
// EXTERNAL MODULE: ./src/hooks/useIsRTL.ts + 1 modules
var useIsRTL = __webpack_require__(36311);
// EXTERNAL MODULE: ./src/hooks/dev/useFastRefreshFixer.tsx
var useFastRefreshFixer = __webpack_require__(78162);
;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/index.tsx



function MaterialPageTabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 20px 0 0;\n  ",
        " {\n    padding: 0 0 0 20px;\n  }\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  overflow: visible;\n  .swiper-slide {\n    width: auto;\n    min-width: min-content;\n    white-space: nowrap;\n    padding-right: 20px;\n    ",
        " {\n      padding-right: 0;\n      padding-left: 20px;\n    }\n  }\n\n  ",
        " {\n    .swiper-slide {\n      width: auto;\n      min-width: 205px;\n    }\n\n    ",
        " {\n      grid-gap: 14px;\n    }\n  }\n  ",
        " {\n    margin-top: 10px;\n  }\n"
    ]);
    MaterialPageTabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MaterialPageTabs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(-1 * var(--header-static-height) - 40px);\n  left: 0;\n"
    ]);
    MaterialPageTabs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var StyledSwiper = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.t).withConfig({
    displayName: "MaterialPageTabs__StyledSwiper",
    componentId: "sc-861ea28c-0"
})(MaterialPageTabs_templateObject(), theme/* dirRTL */.gX, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, NailTab, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ScrollHere = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MaterialPageTabs__ScrollHere",
    componentId: "sc-861ea28c-1"
})(MaterialPageTabs_templateObject1());
var MaterialPageTabs = function(param) {
    var tabs = param.tabs, selectedTab = param.selectedTab, detailsIsVisible = param.detailsIsVisible;
    var _ = (0,lib.useTranslate)()._;
    var isRTL = (0,useIsRTL/* useIsRTL */.S)();
    var key = (0,useFastRefreshFixer/* useFastRefreshFixer */.P)();
    var scrollHere = (0,react.useRef)(null);
    var tabsSwiperRef = (0,react.useRef)();
    var setSelectedTab = (0,useDispatchAction/* useDispatchAction */.W)(actions/* AppAction.detailsPageSetContentTab */.q.detailsPageSetContentTab);
    (0,react.useEffect)(function() {
        var ref;
        (ref = tabsSwiperRef.current) === null || ref === void 0 ? void 0 : ref.slideTo(tabs.findIndex(function(param) {
            var id = param.id;
            return id === selectedTab;
        }));
    }, [
        tabs,
        selectedTab
    ]);
    var selectTab = (0,useCallbackEffects/* useCallbackEffects */._)((0,react.useCallback)((0,eventHandlerHelpers/* valueFromTargetDataset */.d)("value")(setSelectedTab), [
        setSelectedTab, 
    ]), (0,react.useCallback)(function() {
        if (!detailsIsVisible) {
            requestAnimationFrame(function() {
                var ref;
                (ref = scrollHere.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            });
        }
    }, [
        detailsIsVisible,
        selectedTab
    ]));
    var _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiper, {
        dir: isRTL ? "rtl" : "ltr",
        onSwiper: function(swiper) {
            return tabsSwiperRef.current = swiper;
        },
        slidesPerView: "auto",
        wrapperTag: "ul",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollHere, {
                ref: scrollHere
            }),
            tabs.map(function(tab, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NailTab, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                        fade: true,
                        from: "left",
                        delay: 0 + index / 10
                    })), {
                        "data-value": tab.id,
                        onClick: selectTab,
                        $active: selectedTab === tab.id,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabHeader, {
                                children: [
                                    _((_title = tab.title) !== null && _title !== void 0 ? _title : tab.id),
                                    " ",
                                    !!tab.count && "(".concat(tab.count, ")")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabDescription, {
                                children: _(tab.description)
                            })
                        ]
                    }))
                }, tab.id);
            })
        ]
    }, "".concat(isRTL, "-").concat(key));
};

// EXTERNAL MODULE: ./src/components/common/Skeleton.tsx
var Skeleton = __webpack_require__(47536);
// EXTERNAL MODULE: ./src/modules/materials/hooks/useRelatedItemsListQuery.ts + 2 modules
var useRelatedItemsListQuery = __webpack_require__(99448);
// EXTERNAL MODULE: ./src/modules/materials/components/Thumbnail/index.tsx + 6 modules
var Thumbnail = __webpack_require__(87847);
;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageRelatedItems.tsx



function MaterialPageRelatedItems_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin: 24px 0;\n    border-top: 1px solid ",
        ";\n  }\n  ",
        " {\n    min-height: 300px;\n  }\n"
    ]);
    MaterialPageRelatedItems_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MaterialPageRelatedItems_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    MaterialPageRelatedItems_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MaterialPageRelatedItems_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 21px;\n  text-transform: uppercase;\n  color: ",
        ";\n\n  margin: 24px 0 16px;\n  ",
        " {\n    margin: 0 0 24px;\n  }\n"
    ]);
    MaterialPageRelatedItems_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var Container = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "MaterialPageRelatedItems__Container",
    componentId: "sc-e8acb141-0"
})(MaterialPageRelatedItems_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, function(param) {
    var theme = param.theme;
    return theme.skeleton.base;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MaterialPageRelatedItems__ContentContainer",
    componentId: "sc-e8acb141-1"
})(MaterialPageRelatedItems_templateObject1());
var Heading = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "MaterialPageRelatedItems__Heading",
    componentId: "sc-e8acb141-2"
})(MaterialPageRelatedItems_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var MaterialPageRelatedItems = function(param) {
    var item = param.item;
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,useRelatedItemsListQuery/* useRelatedItemsListQuery */.s)(item), relatedItems = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: relatedItems && relatedItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                fade: true
            })), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        children: _("You might like")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                        children: relatedItems.slice(0, 1).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* Thumbnail */.$, {
                                item: item,
                                showTypeLabel: true
                            }, item.id);
                        })
                    })
                ]
            }))
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/index.tsx





function MaterialPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 120vw;\n  height: 592px;\n  margin-left: -20vw;\n"
    ]);
    MaterialPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MaterialPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n"
    ]);
    MaterialPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MaterialPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas: 'tabs' 'content' 'related';\n  gap: 20px;\n  padding: 8px 0;\n\n  ",
        " {\n    grid-template-columns: 883px 360px;\n    grid-template-rows: 50px auto;\n    grid-template-areas: 'tabs related' 'content related';\n    padding: 40px 0;\n    gap: 45px 0;\n  }\n"
    ]);
    MaterialPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MaterialPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  grid-area: tabs;\n"
    ]);
    MaterialPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: content;\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: related;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: row;\n  grid-gap: 25px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}














var HeaderSkeleton = styled_components_browser_esm["default"].header.withConfig({
    displayName: "MaterialPage__HeaderSkeleton",
    componentId: "sc-d311cb51-0"
})(MaterialPage_templateObject());
var MaterialPage_Container = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "MaterialPage__Container",
    componentId: "sc-d311cb51-1"
})(MaterialPage_templateObject1());
var MaterialPage_ContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "MaterialPage__ContentContainer",
    componentId: "sc-d311cb51-2"
})(MaterialPage_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var TabsContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "MaterialPage__TabsContainer",
    componentId: "sc-d311cb51-3"
})(MaterialPage_templateObject3());
var TabContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "MaterialPage__TabContentContainer",
    componentId: "sc-d311cb51-4"
})(_templateObject4());
var RelatedSectionContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "MaterialPage__RelatedSectionContainer",
    componentId: "sc-d311cb51-5"
})(_templateObject5());
var TabContents = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "MaterialPage__TabContents",
    componentId: "sc-d311cb51-6"
})(_templateObject6());
var MaterialPageTemplate = function(param) {
    var tabs = param.tabs, children = param.children, _sourceElement = param.sourceElement, sourceElement = _sourceElement === void 0 ? null : _sourceElement, untranslatedItem = param.item;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useInView */.Y)({
        threshold: 0.2
    }), 2), detailsRef = ref[0], detailsIsVisible = ref[1];
    var selectedTab = (0,es/* useSelector */.v9)(function(s) {
        var ref;
        return s.app.detailsPage.contentTab || ((ref = tabs[0]) === null || ref === void 0 ? void 0 : ref.id);
    });
    (0,usePersonallyCraftedFLIP/* usePersonallyCraftedFLIPSource */.sl)({
        source: sourceElement,
        id: "videoFlip"
    });
    (0,usePersonallyCraftedFLIP/* usePersonallyCraftedFLIPTarget */.Ko)({
        sourceId: "videoThumbnail",
        target: sourceElement
    });
    var item = (0,useTranslateItem/* useTranslateItem */.L)(untranslatedItem);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaterialPage_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaterialPage_ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialPageTabs, {
                            selectedTab: selectedTab,
                            detailsIsVisible: detailsIsVisible,
                            tabs: tabs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContentContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            exitBeforeEnter: true,
                            children: tabs.map(function(param) {
                                var Renderer = param.Renderer, rendererKey = param.rendererKey, id = param.id;
                                return selectedTab === id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContents, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    ref: detailsRef
                                }, (0,transitions/* makeTransition */.Vr)({
                                    stagger: 0.08
                                })), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Renderer, {
                                        item: item
                                    })
                                }), (rendererKey !== null && rendererKey !== void 0 ? rendererKey : item.id) + id) : null;
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedSectionContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialPageRelatedItems, {
                            item: item
                        })
                    })
                ]
            })
        ]
    });
};
var MaterialPageLoader = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(MaterialPage_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
            children: [
                children !== null && children !== void 0 ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSkeleton, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        fill: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabContents, {
                    style: {
                        display: "flex",
                        marginTop: 30
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                            width: "30vw",
                            height: 50,
                            style: {
                                maxWidth: "200px",
                                margin: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                            width: "30vw",
                            height: 50,
                            style: {
                                maxWidth: "200px",
                                margin: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                            width: "30vw",
                            height: 50,
                            style: {
                                maxWidth: "200px",
                                margin: 0
                            }
                        })
                    ]
                })
            ]
        })
    }));
};


/***/ }),

/***/ 71670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ SpeakerTileSkeleton; },
/* harmony export */   "j": function() { return /* binding */ SpeakerTile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87379);
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70057);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var src_modules_user_components_Avatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43029);
/* harmony import */ var src_styles_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12258);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79017);
/* harmony import */ var src_services_route__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38325);
/* harmony import */ var src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47536);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          ",
        " {\n            padding: 32px 20px 50px;\n\n            grid-template: 'avatar' 'text';\n            grid-template-rows: 85px 1fr;\n            justify-items: center;\n            width: 100%;\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template: 'avatar text';\n  grid-template-columns: 35px 1fr;\n  grid-gap: 16px;\n\n  padding: 16px;\n  transition: 0.25s;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  ",
        " {\n    padding: 32px 20px 50px;\n    min-width: 210px;\n    max-width: 270px;\n\n    grid-template: 'avatar' 'text';\n    grid-template-rows: 85px 1fr;\n    justify-items: center;\n    height: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          ",
        " {\n            max-width: 170px;\n            text-align: center;\n          }\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          max-width: 170px;\n          text-align: center;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  font-size: 14px;\n  line-height: 18px;\n\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  word-wrap: break-word;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: uppercase;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          width: 35px;\n          height: 35px;\n\n          ",
        " {\n            width: 78px;\n            height: 78px;\n          }\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          width: 78px;\n          height: 78px;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  padding: 16px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}









var Container = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].a.withConfig({
    displayName: "SpeakerTile__Container",
    componentId: "sc-36f15eef-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, function(param) {
    var $variant = param.$variant;
    switch($variant){
        case "secondary":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__.css)(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);
    }
});
var Figcaption = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].figcaption.withConfig({
    displayName: "SpeakerTile__Figcaption",
    componentId: "sc-36f15eef-1"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var $variant = param.$variant;
    switch($variant){
        case "primary":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__.css)(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
        case "secondary":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__.css)(_templateObject3());
    }
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].p.withConfig({
    displayName: "SpeakerTile__Text",
    componentId: "sc-36f15eef-2"
})(_templateObject5(), (0,src_styles_common__WEBPACK_IMPORTED_MODULE_5__/* .lineClamp */ .Sf)(6));
var Name = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(Text).withConfig({
    displayName: "SpeakerTile__Name",
    componentId: "sc-36f15eef-3"
})(_templateObject6());
var Country = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(Text).withConfig({
    displayName: "SpeakerTile__Country",
    componentId: "sc-36f15eef-4"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var StyledAvatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(src_modules_user_components_Avatar__WEBPACK_IMPORTED_MODULE_4__/* .Avatar */ .qE).withConfig({
    displayName: "SpeakerTile__StyledAvatar",
    componentId: "sc-36f15eef-5"
})(_templateObject10(), function(param) {
    var $variant = param.$variant;
    switch($variant){
        case "primary":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__.css)(_templateObject8(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
        case "secondary":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__.css)(_templateObject9());
    }
});
var SpeakerTile = function(_param) {
    var _speaker = _param.speaker, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "speaker",
        "variant"
    ]);
    var ref;
    var translateItem = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_2__/* .useTranslateItem */ .L)();
    var speaker = translateItem(_speaker);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_6__/* .TrackedLink */ .A, {
        href: src_services_route__WEBPACK_IMPORTED_MODULE_7__/* .route.search */ .BC.search({
            speaker: speaker.name
        }).videos(),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
            $variant: variant
        }, props), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAvatar, {
                    $variant: variant,
                    src: (ref = speaker.avatar) === null || ref === void 0 ? void 0 : ref.id,
                    sizes: "100px"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Figcaption, {
                    $variant: variant,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Name, {
                            children: [
                                speaker.degree ? "".concat(speaker.degree, "\xa0") : "",
                                speaker.name
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                            children: speaker.title
                        }),
                        speaker.country && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Country, {
                            children: translateItem(speaker.country).name
                        })
                    ]
                })
            ]
        }))
    });
};
var SkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div.withConfig({
    displayName: "SpeakerTile__SkeletonContainer",
    componentId: "sc-36f15eef-6"
})(_templateObject11());
var SpeakerTileSkeleton = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SkeletonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        as: "div"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                width: "78px",
                height: "78px",
                style: {
                    borderRadius: "50%",
                    marginBottom: "20px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                width: "120px",
                height: "20px"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                width: "160px",
                height: "20px"
            })
        ]
    }));
};


/***/ }),

/***/ 8469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ tabsFactory; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/components/icons/File.tsx
var File = __webpack_require__(19838);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(10763);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/components/common/typography/Header.tsx
var Header = __webpack_require__(29894);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
// EXTERNAL MODULE: ./src/services/directus/common.ts
var common = __webpack_require__(6050);
;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/NotesTab.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 16px;\n  border-bottom: 1px solid\n    ",
        ";\n  &:hover,\n  &:focus {\n    h3 {\n      color: ",
        ";\n    }\n  }\n  & + & {\n    padding-top: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 21px;\n  color: ",
        ";\n  margin-bottom: 5px;\n  text-transform: uppercase;\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 18px;\n  color: ",
        ";\n  transition: 0.2s;\n  ",
        " {\n    font-size: 20px;\n    line-height: 24px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 21px;\n  color: ",
        ";\n  margin-top: 12px;\n  ",
        " {\n    font-size: 16px;\n    line-height: 24px;\n    margin-top: 7px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  grid-gap: 24px;\n  ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    padding-top: 10px;\n    grid-gap: 40px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  &:hover,\n  &:focus {\n    h3 {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-right: 15px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 750px;\n  & > ",
        " {\n    margin-bottom: 20px;\n  }\n  & + & {\n    margin-top: 20px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}














var Article = styled_components_browser_esm["default"].article.withConfig({
    displayName: "NotesTab__Article",
    componentId: "sc-afb9cf36-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.75, theme.text.palette.secondary);
}, function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var ArticleType = styled_components_browser_esm["default"].span.withConfig({
    displayName: "NotesTab__ArticleType",
    componentId: "sc-afb9cf36-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ArticleName = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "NotesTab__ArticleName",
    componentId: "sc-afb9cf36-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ArticleDescription = styled_components_browser_esm["default"].p.withConfig({
    displayName: "NotesTab__ArticleDescription",
    componentId: "sc-afb9cf36-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ArticleBox = function(props) {
    var article = props.article;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Article, {
        as: "a",
        href: article.url,
        target: "_blank",
        rel: "noopener",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleType, {
                children: _("article")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleName, {
                children: article.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleDescription, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    children: article.description
                })
            })
        ]
    });
};
var FileList = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "NotesTab__FileList",
    componentId: "sc-afb9cf36-4"
})(_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var NotesTab_File = styled_components_browser_esm["default"].a.withConfig({
    displayName: "NotesTab__File",
    componentId: "sc-afb9cf36-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NotesTab__IconWrapper",
    componentId: "sc-afb9cf36-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var FileBox = function(props) {
    var file = props.file;
    var isDesktop = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotesTab_File, {
        href: (0,common/* getDirectusImageAssetUrl */.yF)(file.file.id, {
            download: true
        }),
        target: "_blank",
        rel: "noopener",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(File/* File */.$, {
                    size: isDesktop ? 32 : 23
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleName, {
                    children: file.name
                })
            })
        ]
    });
};
var AttachementList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NotesTab__AttachementList",
    componentId: "sc-afb9cf36-7"
})(_templateObject7(), Header.H2);
var NotesTab = function(param) {
    var item = param.item;
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var _ = (0,lib.useTranslate)()._;
    var ref;
    var articles = (0,react.useMemo)(function() {
        var ref1;
        return item && "attachments" in item ? (ref = item === null || item === void 0 ? void 0 : (ref1 = item.attachments) === null || ref1 === void 0 ? void 0 : ref1.map(function(a) {
            return a.attachments_id;
        }).filter(function(a) {
            return a.type === "article";
        }).map(translateItem)) !== null && ref !== void 0 ? ref : [] : [];
    }, [
        item,
        translateItem
    ]);
    var ref1;
    var files = (0,react.useMemo)(function() {
        var ref;
        return item && "attachments" in item ? (ref1 = item === null || item === void 0 ? void 0 : (ref = item.attachments) === null || ref === void 0 ? void 0 : ref.map(function(a) {
            return a.attachments_id;
        }).filter(function(a) {
            return a.type === "file";
        }).map(translateItem)) !== null && ref1 !== void 0 ? ref1 : [] : [];
    }, [
        item,
        translateItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            articles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttachementList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header.H2, {
                        as: motion/* motion.h3 */.E.h3,
                        variants: (0,transitions/* makeTransition */.Vr)({
                            fade: true,
                            from: "bottomMore"
                        }),
                        children: _("Links")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        variants: (0,transitions/* makeTransition */.Vr)({
                            fade: true,
                            from: "bottomMore"
                        }),
                        children: articles.map(function(article) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleBox, {
                                article: article
                            }, article.id);
                        })
                    })
                ]
            }),
            files.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttachementList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header.H2, {
                        as: motion/* motion.h3 */.E.h3,
                        variants: (0,transitions/* makeTransition */.Vr)({
                            fade: true,
                            from: "bottomMore"
                        }),
                        children: _("Files to download")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FileList, {
                        variants: (0,transitions/* makeTransition */.Vr)({
                            fade: true,
                            from: "bottomMore"
                        }),
                        children: files.map(function(file) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FileBox, {
                                file: file
                            }, file.id);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/modules/materials/components/SpeakerTile.tsx
var SpeakerTile = __webpack_require__(71670);
;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/DetailsTab.tsx

function DetailsTab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  line-height: 150%;\n  font-size: 14px;\n  color: ",
        ";\n\n  ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    DetailsTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailsTab_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: row;\n  grid-gap: 15px;\n"
    ]);
    DetailsTab_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailsTab_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: row;\n  grid-gap: 13px;\n\n  ",
        " {\n    display: flex;\n    flex-direction: row;\n\n    margin: 0px -10px;\n\n    & > * {\n      margin: 10px;\n    }\n  }\n"
    ]);
    DetailsTab_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var Description = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "DetailsTab__Description",
    componentId: "sc-dd661c06-0"
})(DetailsTab_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Speakers = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "DetailsTab__Speakers",
    componentId: "sc-dd661c06-1"
})(DetailsTab_templateObject1());
var SpeakersList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "DetailsTab__SpeakersList",
    componentId: "sc-dd661c06-2"
})(DetailsTab_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var DetailsTab = function(param) {
    var item = param.item;
    var _ = (0,lib.useTranslate)()._;
    var speakers = item && "speakers" in item ? item.speakers : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                variants: (0,transitions/* makeTransition */.Vr)({
                    fade: true,
                    from: "bottomMore"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    children: item.description
                })
            }),
            Number(speakers === null || speakers === void 0 ? void 0 : speakers.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Speakers, {
                variants: (0,transitions/* makeTransition */.Vr)({
                    fade: true,
                    from: "bottomMore"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header.H2, {
                        as: "h3",
                        children: _("Featuring")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakersList, {
                        children: speakers === null || speakers === void 0 ? void 0 : speakers.map(function(s) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerTile/* SpeakerTile */.j, {
                                    speaker: s.people_id
                                })
                            }, s.people_id.id);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/PimImage.tsx
var PimImage = __webpack_require__(43573);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
// EXTERNAL MODULE: ./src/components/common/Swipers/ContentSwiper.tsx
var ContentSwiper = __webpack_require__(77314);
// EXTERNAL MODULE: ./src/modules/materials/components/ShowcasePage/common.tsx
var ShowcasePage_common = __webpack_require__(52178);
;// CONCATENATED MODULE: ./src/components/common/Swipers/ProductsSwiper.tsx

function ProductsSwiper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n\n  .swiper-wrapper {\n    height: auto;\n  }\n\n  .swiper-slide {\n    width: auto;\n    display: flex;\n  }\n\n  &&& {\n    ",
        " {\n      top: 30%;\n      transform: translateY(-30%);\n      z-index: 9;\n    }\n  }\n"
    ]);
    ProductsSwiper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProductsSwiper = (0,styled_components_browser_esm["default"])(ContentSwiper/* ContentSwiper */.o).withConfig({
    displayName: "ProductsSwiper",
    componentId: "sc-83471202-0"
})(ProductsSwiper_templateObject(), ShowcasePage_common/* NavigationButton */.W);

// EXTERNAL MODULE: ./src/modules/products/hooks/useProductDetailsQuery.ts
var useProductDetailsQuery = __webpack_require__(63281);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/ProductsTab.tsx

function ProductsTab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: grid;\n    grid-template:\n      'image name'\n      'image description'\n      'image link';\n\n    grid-template-columns: 118px 1fr;\n    grid-template-rows: auto 1fr auto;\n    gap: 13px 19px;\n    margin: 0 0 36px;\n  }\n\n  ",
        " {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 264px;\n    gap: 17px;\n    margin: 0 20px 0 0;\n  }\n"
    ]);
    ProductsTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsTab_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: image;\n  position: relative;\n  width: 104px;\n  height: 108px;\n  margin: 0 10px;\n\n  img {\n    object-fit: contain;\n  }\n\n  ",
        " {\n    width: 229px;\n    height: 229px;\n    margin: 9px;\n  }\n"
    ]);
    ProductsTab_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductsTab_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: name;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  color: ",
        ";\n\n  ",
        " {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 18px;\n    text-align: center;\n  }\n"
    ]);
    ProductsTab_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductsTab_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: description;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 18px;\n  color: ",
        ";\n\n  ",
        " {\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 18px;\n    margin-bottom: 18px;\n    text-align: center;\n    flex: 1;\n  }\n"
    ]);
    ProductsTab_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductsTab_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: link;\n\n  ",
        " {\n    ",
        " {\n      min-width: 162px !important;\n    }\n  }\n"
    ]);
    ProductsTab_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

















var Product = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ProductsTab__Product",
    componentId: "sc-77b4fd8a-0"
})(ProductsTab_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsTab__ProductImage",
    componentId: "sc-77b4fd8a-1"
})(ProductsTab_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsTab__ProductName",
    componentId: "sc-77b4fd8a-2"
})(ProductsTab_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductDescription = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsTab__ProductDescription",
    componentId: "sc-77b4fd8a-3"
})(ProductsTab_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductLink = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsTab__ProductLink",
    componentId: "sc-77b4fd8a-4"
})(ProductsTab_templateObject4(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, Button/* ButtonContainer */.qO);
var ProductBox = function(param) {
    var code = param.code;
    var _ = (0,lib.useTranslate)()._;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref = (0,useProductDetailsQuery/* useProductDetailsQuery */.c)(code), product = ref.data;
    if (!product) {
        return null;
    }
    var _description_short;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
        href: route/* route.products */.BC.products().page(product),
        passHref: true,
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Product, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                    children: product.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                        src: product.image.id,
                        sizes: "30vw",
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                    children: translateFn(product).name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: (_description_short = translateFn(product).description_short) !== null && _description_short !== void 0 ? _description_short : ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLink, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        compound: true,
                        forwardedAs: "span",
                        children: _("Read more")
                    })
                })
            ]
        })
    });
};
var ProductsTab = function(param) {
    var item = param.item;
    var _ = (0,lib.useTranslate)()._;
    var isMobile = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
    var _products;
    var products = item && "products" in item ? (_products = item.products) !== null && _products !== void 0 ? _products : [] : null;
    if (!products) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header.H2, {
                as: motion/* motion.h3 */.E.h3,
                variants: (0,transitions/* makeTransition */.Vr)({
                    fade: true,
                    from: "bottomMore"
                }),
                children: _("PRODUCTS")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                variants: (0,transitions/* makeTransition */.Vr)({
                    fade: true,
                    from: "bottomMore"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSwiper, {
                    direction: isMobile ? "vertical" : "horizontal",
                    children: products.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                            tag: "li",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBox, {
                                code: product.products_id.pim_code
                            })
                        }, product.id);
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/common/FormatDate.tsx
var FormatDate = __webpack_require__(23955);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
// EXTERNAL MODULE: ./node_modules/@summer/jst-react-icon/lib/index.js
var jst_react_icon_lib = __webpack_require__(55537);
;// CONCATENATED MODULE: ./src/components/icons/Edit.tsx




var Edit = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jst_react_icon_lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m49.324 4.57 10.607 10.606-7.778 7.778-10.607-10.607 7.778-7.778ZM38.132 15.761l10.606 10.606-31.628 31.63-9.85-.758-.757-9.85 31.629-31.628Zm0 5.657-27.5 27.5.354 4.595 4.596.354 27.5-27.5-4.95-4.95Z"
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Delete.tsx




var Delete = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jst_react_icon_lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.96 10.88H43.52V3.2H20.48v7.68H7.04v3.84h3.84V60.8h42.24V14.72h3.84v-3.84ZM24.32 7.04h15.36v3.84H24.32V7.04Zm24.96 49.92H14.72V14.72h34.56v42.24Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.48 20.48h3.84V51.2h-3.84V20.48ZM30.08 20.48h3.84V51.2h-3.84V20.48ZM39.68 20.48h3.84V51.2h-3.84V20.48Z"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/components/common/Popup/index.tsx
var Popup = __webpack_require__(76088);
// EXTERNAL MODULE: ./src/components/common/Button/withAnimationController.ts
var withAnimationController = __webpack_require__(33572);
;// CONCATENATED MODULE: ./src/components/common/Popup/ConfirmationPopup.tsx






function ConfirmationPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: auto;\n  height: auto;\n"
    ]);
    ConfirmationPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConfirmationPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n"
    ]);
    ConfirmationPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConfirmationPopup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  line-height: 1.3;\n  font-weight: 300;\n  text-transform: uppercase;\n"
    ]);
    ConfirmationPopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConfirmationPopup_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 18px;\n  margin: 8px 0 0;\n"
    ]);
    ConfirmationPopup_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ConfirmationPopup_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 40px;\n"
    ]);
    ConfirmationPopup_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var StyledPopup = (0,styled_components_browser_esm["default"])(Popup/* Popup */.G).withConfig({
    displayName: "ConfirmationPopup__StyledPopup",
    componentId: "sc-aa984232-0"
})(ConfirmationPopup_templateObject());
var Form = styled_components_browser_esm["default"].form.withConfig({
    displayName: "ConfirmationPopup__Form",
    componentId: "sc-aa984232-1"
})(ConfirmationPopup_templateObject1());
var Title = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "ConfirmationPopup__Title",
    componentId: "sc-aa984232-2"
})(ConfirmationPopup_templateObject2());
var ConfirmationPopup_Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "ConfirmationPopup__Description",
    componentId: "sc-aa984232-3"
})(ConfirmationPopup_templateObject3());
var ActionsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ConfirmationPopup__ActionsContainer",
    componentId: "sc-aa984232-4"
})(ConfirmationPopup_templateObject4());
var ConfirmationPopup = function(_param) {
    var title = _param.title, description = _param.description, submitText = _param.submitText, onConfirm = _param.onConfirm, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "submitText",
        "onConfirm",
        "onCancel"
    ]);
    var animationControllerRef = (0,react.useRef)(null);
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPopup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
            onSubmit: (0,withAnimationController/* withAnimationController */.h)(animationControllerRef, function(e) {
                e.preventDefault();
                return onConfirm();
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationPopup_Description, {
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            type: "submit",
                            variant: "secondary",
                            stateControllerRef: animationControllerRef,
                            children: submitText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            kind: "text",
                            onClick: onCancel,
                            type: "button",
                            children: _("Cancel")
                        })
                    ]
                })
            ]
        })
    }));
};
var WithConfirmation = function(_param) {
    var children = _param.children, onConfirm = _param.onConfirm, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "onConfirm",
        "onCancel"
    ]);
    var ref = (0,react.useState)(false), popupVisible = ref[0], setPopupVisible = ref[1];
    var clickCallback = (0,react.useCallback)(function(e) {
        var _props, ref;
        (ref = (_props = children.props).onClick) === null || ref === void 0 ? void 0 : ref.call(_props, e);
        setPopupVisible(true);
    }, [
        children.props
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,react.cloneElement)(children, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, children.props), {
                onClick: function(e) {
                    return clickCallback(e);
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationPopup, (0,_object_spread/* default */.Z)({
                visible: popupVisible,
                close: function() {
                    return setPopupVisible(false);
                },
                onCancel: function() {
                    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                    setPopupVisible(false);
                },
                onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onConfirm()
                                ];
                            case 1:
                                _state.sent();
                                setTimeout(function() {
                                    setPopupVisible(false);
                                }, 300);
                                return [
                                    2
                                ];
                        }
                    });
                })
            }, props))
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/components/common/Textarea.tsx + 1 modules
var Textarea = __webpack_require__(4643);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/user/graphql/user-notes-create.mutation.ts

function user_notes_create_mutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ($data: create_notes_input!) {\n    create_notes_item(data: $data) {\n      id\n      date_created\n      content\n    }\n  }\n"
    ]);
    user_notes_create_mutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var createUserNoteGqlMutation = (0,gql_query/* gql */.Ps)(user_notes_create_mutation_templateObject());

// EXTERNAL MODULE: ./src/modules/user/hooks/useUserNotesQuery.ts + 1 modules
var useUserNotesQuery = __webpack_require__(82191);
;// CONCATENATED MODULE: ./src/modules/materials/hooks/useMaterialsCreateUserNoteMutation.ts










var useMaterialsCreateUserNoteMutation = function(item) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var queryClient = (0,es.useQueryClient)();
    return (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var directus, result, updated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            4,
                            directus.mutate(createUserNoteGqlMutation, {
                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                    targetId: item.id
                                })
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            4,
                            (0,useUserNotesQuery/* fetchUserNotes */.d)(apis, item.id)
                        ];
                    case 3:
                        updated = _state.sent();
                        queryClient.setQueryData((0,_to_consumable_array/* default */.Z)(query/* QueryKey.MaterialsUserNotes */.S.MaterialsUserNotes).concat([
                            item.id
                        ]), function() {
                            return updated;
                        });
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
};

;// CONCATENATED MODULE: ./src/modules/user/graphql/user-note-update.mutation.ts

function user_note_update_mutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ($id: ID!, $data: update_notes_input!) {\n    update_notes_item(id: $id, data: $data) {\n      id\n      date_created\n      content\n    }\n  }\n"
    ]);
    user_note_update_mutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var updateUserNoteGqlMutation = (0,gql_query/* gql */.Ps)(user_note_update_mutation_templateObject());

;// CONCATENATED MODULE: ./src/modules/materials/hooks/useMaterialsUpdateUserNoteMutation.ts











var useMaterialsUpdateUserNoteMutation = function(item) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var queryClient = (0,es.useQueryClient)();
    return (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
            var id, data, directus, result, updated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = _param.id, data = (0,_object_without_properties/* default */.Z)(_param, [
                            "id"
                        ]);
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            4,
                            directus.mutate(updateUserNoteGqlMutation, {
                                id: id,
                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                    targetId: item.id
                                })
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            4,
                            (0,useUserNotesQuery/* fetchUserNotes */.d)(apis, item.id)
                        ];
                    case 3:
                        updated = _state.sent();
                        queryClient.setQueryData((0,_to_consumable_array/* default */.Z)(query/* QueryKey.MaterialsUserNotes */.S.MaterialsUserNotes).concat([
                            item.id
                        ]), function() {
                            return updated;
                        });
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }());
};

;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/UserNotesTab/UserNoteForm.tsx





function UserNoteForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 24px;\n  padding-top: 16px;\n"
    ]);
    UserNoteForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserNoteForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    min-width: 200px;\n  }\n"
    ]);
    UserNoteForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








// import { FormikPageLeaveBlocker } from 'src/components/common/PageLeaveBlocker';





var UserNoteForm_ActionsContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "UserNoteForm__ActionsContainer",
    componentId: "sc-e4c14ad-0"
})(UserNoteForm_templateObject());
var SubmitButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "UserNoteForm__SubmitButton",
    componentId: "sc-e4c14ad-1"
})(UserNoteForm_templateObject1());
var UserNoteForm = function(param) {
    var item = param.item, note = param.note, onSubmit = param.onSubmit, onCancel = param.onCancel;
    var _ = (0,lib.useTranslate)()._;
    var animationControllerRef = (0,react.useRef)(null);
    var isEditMode = !!note;
    var create = useMaterialsCreateUserNoteMutation(item);
    var update = useMaterialsUpdateUserNoteMutation(item);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            content: (ref = note === null || note === void 0 ? void 0 : note.content) !== null && ref !== void 0 ? ref : ""
        },
        onSubmit: (0,withAnimationController/* withAnimationController */.h)(animationControllerRef, function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values, formik) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isEditMode) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                update.mutateAsync({
                                    id: note.id,
                                    content: values.content
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                create.mutateAsync({
                                    content: values.content
                                })
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                            formik.resetForm();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, formik) {
                return _ref.apply(this, arguments);
            };
        }()),
        children: function(param) {
            var dirty = param.dirty, resetForm = param.resetForm;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                as: motion/* motion.div */.E.div
            }, (0,transitions/* makeTransition */.Vr)({
                fade: "enter"
            })), {
                layout: "position",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* TextareaFormik */.h, {
                        name: "content",
                        placeholder: _(isEditMode ? "Edit a note" : "Write a note")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: (dirty || isEditMode) && /*#__PURE__*/ (0,react.createElement)(UserNoteForm_ActionsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            layout: "position"
                        }, (0,transitions/* makeTransition */.Vr)({
                            fade: true,
                            from: "top",
                            sortZIndex: true
                        })), {
                            key: "actions",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                    kind: "text",
                                    onClick: function() {
                                        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                                        resetForm();
                                    },
                                    type: "button",
                                    children: _("Cancel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                                    type: "submit",
                                    variant: "secondary",
                                    stateControllerRef: animationControllerRef,
                                    children: _(isEditMode ? "Save" : "Add note")
                                })
                            ]
                        }))
                    })
                ]
            }));
        }
    });
};

// EXTERNAL MODULE: ./src/components/common/ExpandableContent/ExpandButton.tsx
var ExpandButton = __webpack_require__(20516);
// EXTERNAL MODULE: ./node_modules/react-uid/dist/es2015/hooks.js + 2 modules
var hooks = __webpack_require__(34699);
// EXTERNAL MODULE: ./src/components/common/ScrollToSectionOnClick.tsx
var ScrollToSectionOnClick = __webpack_require__(16001);
;// CONCATENATED MODULE: ./src/components/common/ExpandableContent/index.tsx





function ExpandableContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 40px;\n    bottom: 0;\n    opacity: ",
        ";\n    transition: 0.25s;\n    background: ",
        ";\n  }\n"
    ]);
    ExpandableContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Content = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).attrs({
    initial: "collapsed",
    exit: "collapsed",
    transition: {
        duration: 0.3,
        ease: [
            0.04,
            0.62,
            0.23,
            0.98
        ]
    }
}).withConfig({
    displayName: "ExpandableContent__Content",
    componentId: "sc-ec415b53-0"
})(ExpandableContent_templateObject(), function(param) {
    var $visible = param.$visible;
    return $visible ? 0 : 1;
}, function(param) {
    var theme = param.theme;
    return "linear-gradient(rgba(245, 246, 248, 0), ".concat((0,polished_esm/* transparentize */.DZ)(0.2, theme.skeleton.highlight), " 50%)");
});
var isOverflowing = function(element) {
    return element ? element.scrollHeight > element.clientHeight : false;
};
var ExpandableContent = function(_param) {
    var children = _param.children, _height = _param.height, height = _height === void 0 ? 95 : _height, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "height"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isExpanded = ref[0], toggleIsExpanded = ref[1];
    var ref1 = (0,react.useRef)(null);
    var id = (0,hooks/* useUID */.D)();
    var ref2 = (0,react.useState)(!isExpanded && isOverflowing(ref1.current)), isContentOverflowing = ref2[0], setIsContentOverflowing = ref2[1];
    (0,react.useEffect)(function() {
        if (!isExpanded) {
            setIsContentOverflowing(isOverflowing(ref1.current));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        children
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: "expandable-".concat(id)
    }, (0,transitions/* makeTransition */.Vr)({
        fade: true
    }), props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    ref: ref1,
                    $visible: isExpanded || !isContentOverflowing,
                    animate: isExpanded ? "open" : "collapsed",
                    variants: {
                        open: {
                            height: "auto"
                        },
                        collapsed: {
                            height: "calc(var(--base-unit) * ".concat(height, ")")
                        }
                    },
                    children: children
                })
            }),
            isContentOverflowing && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToSectionOnClick/* ScrollToSectionOnClick */.d, {
                id: "expandable-".concat(id),
                offset: 60,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButton/* ExpandButton */.V, {
                    active: isExpanded,
                    onClick: toggleIsExpanded
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/modules/user/graphql/user-note-delete.mutation.ts

function user_note_delete_mutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ($id: ID!) {\n    delete_notes_item(id: $id) {\n      id\n    }\n  }\n"
    ]);
    user_note_delete_mutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var deleteUserNoteGqlMutation = (0,gql_query/* gql */.Ps)(user_note_delete_mutation_templateObject());

;// CONCATENATED MODULE: ./src/modules/materials/hooks/useMaterialsDeleteUserNoteMutation.ts








var useMaterialsDeleteUserNoteMutation = function(item) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var queryClient = (0,es.useQueryClient)();
    return (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(variables) {
            var directus, result, updated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            4,
                            directus.mutate(deleteUserNoteGqlMutation, variables)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            4,
                            (0,useUserNotesQuery/* fetchUserNotes */.d)(apis, item.id)
                        ];
                    case 3:
                        updated = _state.sent();
                        queryClient.setQueryData((0,_to_consumable_array/* default */.Z)(query/* QueryKey.MaterialsUserNotes */.S.MaterialsUserNotes).concat([
                            item.id
                        ]), function() {
                            return updated;
                        });
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }());
};

;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/UserNotesTab/UserNote.tsx




function UserNote_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas: 'date actions' 'content content';\n  gap: 16px;\n\n  padding: 16px 0;\n  border-top: 1px solid ",
        ";\n\n  ",
        " {\n    grid-template-columns: 120px auto 120px;\n    grid-template-areas: 'date content actions';\n  }\n"
    ]);
    UserNote_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserNote_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: date;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 1.25;\n"
    ]);
    UserNote_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserNote_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  text-transform: uppercase;\n"
    ]);
    UserNote_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UserNote_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: content;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 1.5;\n"
    ]);
    UserNote_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function UserNote_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 12px;\n"
    ]);
    UserNote_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function UserNote_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -4px;\n  margin-bottom: 16px;\n"
    ]);
    UserNote_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function UserNote_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: actions;\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n"
    ]);
    UserNote_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
















var Container = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "UserNote__Container",
    componentId: "sc-70b2301e-0"
})(UserNote_templateObject(), function(param) {
    var theme = param.theme;
    return theme.skeleton.base;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var DateContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserNote__DateContainer",
    componentId: "sc-70b2301e-1"
})(UserNote_templateObject1());
var UserNote_Date = styled_components_browser_esm["default"].p.withConfig({
    displayName: "UserNote__Date",
    componentId: "sc-70b2301e-2"
})(UserNote_templateObject2());
var ContentColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserNote__ContentColumn",
    componentId: "sc-70b2301e-3"
})(UserNote_templateObject3());
var FormContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "UserNote__FormContainer",
    componentId: "sc-70b2301e-4"
})(UserNote_templateObject4());
var UserNote_Content = styled_components_browser_esm["default"].p.withConfig({
    displayName: "UserNote__Content",
    componentId: "sc-70b2301e-5"
})(UserNote_templateObject5());
var UserNote_ActionsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserNote__ActionsContainer",
    componentId: "sc-70b2301e-6"
})(UserNote_templateObject6());
var UserNote = function(param) {
    var item = param.item, note = param.note;
    var date_created = note.date_created, content = note.content;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isEditable = ref[0], toggleIsEditable = ref[1];
    var _ = (0,lib.useTranslate)()._;
    var mutate = useMaterialsDeleteUserNoteMutation(item).mutate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
        fade: true
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DateContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNote_Date, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                            format: "dd MMMM yyyy",
                            children: date_created
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                        children: date_created
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentColumn, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    exitBeforeEnter: true,
                    children: isEditable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                        fade: true
                    })), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNoteForm, {
                            item: item,
                            note: note,
                            onCancel: function() {
                                return toggleIsEditable(false);
                            },
                            onSubmit: function() {
                                return toggleIsEditable(false);
                            }
                        }, "editable")
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableContent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNote_Content, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                allowedTokens: [
                                    /\n/
                                ],
                                children: content
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserNote_ActionsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        kind: "circled",
                        size: "small",
                        icon: Edit,
                        onClick: function() {
                            return toggleIsEditable();
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WithConfirmation, {
                        title: _("Delete note?"),
                        description: _("Are you sure you want to delete the note?"),
                        submitText: _("Yes, delete"),
                        onConfirm: function() {
                            return mutate({
                                id: note.id
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            kind: "circled",
                            size: "small",
                            icon: Delete
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/UserNotesTab/index.tsx



function UserNotesTab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 0 24px;\n  ",
        " {\n    padding: 0 0 32px;\n  }\n"
    ]);
    UserNotesTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var UserNotesTab_FormContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "UserNotesTab__FormContainer",
    componentId: "sc-ef680be7-0"
})(UserNotesTab_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var UserNotesTab = function(param) {
    var item = param.item;
    var ref = (0,useUserNotesQuery/* useUserNotesQuery */.I)(item), notes = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
        fade: true,
        from: "top"
    })), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            initial: false,
            exitBeforeEnter: true,
            children: item && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNotesTab_FormContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNoteForm, {
                            item: item
                        })
                    }),
                    notes === null || notes === void 0 ? void 0 : notes.map(function(note) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNote, {
                            item: item,
                            note: note
                        }, note.id);
                    })
                ]
            })
        })
    }), "notes");
};

// EXTERNAL MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/types.ts
var types = __webpack_require__(78939);
;// CONCATENATED MODULE: ./src/modules/materials/utils/tabsFactory.ts







var _obj;
var tabConfigsMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types/* MaterialPageTabId.Notes */.z.Notes, {
    description: "Files to download, links",
    Renderer: NotesTab,
    renderCondition: function(item) {
        var ref;
        return !!(item && "attachments" in item && ((ref = item.attachments) === null || ref === void 0 ? void 0 : ref.length) > 0);
    }
}), (0,_define_property/* default */.Z)(_obj, types/* MaterialPageTabId.UserNotes */.z.UserNotes, {
    title: "NOTES",
    description: "Add your notes",
    Renderer: UserNotesTab
}), (0,_define_property/* default */.Z)(_obj, types/* MaterialPageTabId.Details */.z.Details, {
    description: "About the talk",
    Renderer: DetailsTab
}), (0,_define_property/* default */.Z)(_obj, types/* MaterialPageTabId.Products */.z.Products, {
    description: "From this video",
    Renderer: ProductsTab,
    renderCondition: function(item) {
        var ref;
        return !!(item && "products" in item && ((ref = item.products) === null || ref === void 0 ? void 0 : ref.length) > 0);
    }
}), _obj);
var tabsFactory = function(item) {
    return function(config) {
        return config.reduce(function(prev, tab) {
            if (typeof tab === "string") {
                var ref;
                var tabConfig = tabConfigsMap[tab];
                var ref1;
                if (tabConfig && ((ref1 = (ref = tabConfig.renderCondition) === null || ref === void 0 ? void 0 : ref.call(tabConfig, item)) !== null && ref1 !== void 0 ? ref1 : true)) {
                    prev.push((0,_object_spread/* default */.Z)({
                        id: tab
                    }, tabConfig));
                }
            } else {
                var ref2;
                var defaultConfig = tabConfigsMap[tab.id];
                var tabConfig1 = (0,_object_spread/* default */.Z)({}, defaultConfig, tab);
                var ref3;
                if ((ref3 = (ref2 = tabConfig1.renderCondition) === null || ref2 === void 0 ? void 0 : ref2.call(tabConfig1, item)) !== null && ref3 !== void 0 ? ref3 : true) {
                    prev.push(tabConfig1);
                }
            }
            return prev;
        }, []);
    };
};


/***/ }),

/***/ 82191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ fetchUserNotes; },
  "I": function() { return /* binding */ useUserNotesQuery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/user/graphql/user-notes.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query UserNotesQuery($filters: notes_filter) {\n    notes(filter: $filters, sort: ["-date_created"]) {\n      id\n      content\n      date_created\n      targetId\n      targetCollection\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var userNotesGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./src/modules/user/hooks/useUserPermissions.ts
var useUserPermissions = __webpack_require__(65533);
;// CONCATENATED MODULE: ./src/modules/user/hooks/useUserNotesQuery.ts










var fetchUserNotes = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, itemId) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(userNotesGqlQuery, {
                            filters: {
                                targetId: {
                                    _eq: itemId
                                }
                            }
                        }).then(function(a) {
                            return a.notes;
                        })
                    ];
            }
        });
    });
    return function fetchUserNotes(apis, itemId) {
        return _ref.apply(this, arguments);
    };
}();
var useUserNotesQuery = function(item, options) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useUserPermissions/* useUserPermissions */.Q)(), 1), userPermissions = ref[0];
    return (0,es.useQuery)((0,_to_consumable_array/* default */.Z)(query/* QueryKey.MaterialsUserNotes */.S.MaterialsUserNotes).concat([
        item === null || item === void 0 ? void 0 : item.id
    ]), function() {
        return item != null ? fetchUserNotes(apis, item.id) : [];
    }, (0,_object_spread/* default */.Z)({
        enabled: item != null && userPermissions.kol
    }, options));
};


/***/ }),

/***/ 89755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ valueFromTargetDataset; }
/* harmony export */ });
/* unused harmony export valueFromTargetValue */
/**
 *  const selectTab = valueFromTargetDataset('value')((value) => {
 *    console.log(value); // value = "DETAILS"
 *  });
 *
 *  <button data-value="DETAILS" onClick={selectTab}/>
 *
 * @param datasetKey
 */ var valueFromTargetDataset = function(datasetKey) {
    return function(handler) {
        return function(e) {
            return handler(e.currentTarget.dataset[datasetKey]);
        };
    };
};
/**
 *  const selectTab =
 *  valueFromTargetValue((value) => {
 *    console.log(value); // value = "DETAILS"
 *  });
 *
 *  <select onChange={selectTab}>
 *    <option value="DETAILS"/>
 *  </select>
 *
 * @param handler
 */ var valueFromTargetValue = function(handler) {
    return function(e) {
        return handler(e.currentTarget.value);
    };
};


/***/ }),

/***/ 33403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ publicUrl; }
/* harmony export */ });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);

var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
/**
 * Gets an asset path taking in account a basePath if it is set
 * @param uri
 */ function publicUrl(uri) {
    return publicRuntimeConfig.basePath ? uri.replace(/^\//, publicRuntimeConfig.basePath.replace(/\/?$/, "/")) : uri;
}


/***/ })

}]);